(self["webpackChunkPaper"] = self["webpackChunkPaper"] || []).push([["/assets/main"],{

/***/ "./src/js/bsl.js":
/*!***********************!*\
  !*** ./src/js/bsl.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// setup basic variables
var bsl = {}; // SHOPIFY
// ========

var Shopify = window.Shopify || {};
Shopify.money_format = "${{ amount }}";

Shopify.formatMoney = function (cents, currency) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }

  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = currency ? "".concat(currency + "{{ amount }}") : this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;

    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}; // GLOBAL
// ========
// - expose functions to alpine


window.app = function () {
  return {
    hide_header: window.__intialData.hide_header,
    theme_color: window.__intialData.theme_color,
    menu_drawer: window.__intialData.menu_drawer,
    menu_nested: window.__intialData.menu_nested,
    age_popup: window.__intialData.age_popup,
    color_popup: window.__intialData.color_popup,
    filter_popup: window.__intialData.filter_popup,
    localization_popup: window.__intialData.localization_popup,
    scroll_up: window.__intialData.scroll_up,
    scroll_up_force: window.__intialData.scroll_up_force,
    mouse_x: window.__intialData.mouse_x,
    mouse_y: window.__intialData.mouse_y,
    show_alert: window.__intialData.show_alert,
    error_title: window.__intialData.error_title,
    error_message: window.__intialData.error_message,
    animate_index: window.__intialData.animate_index,
    recent_products: window.__intialData.recent_products,
    incomplete_fields: window.__intialData.incomplete_fields,
    cart_drawer: window.__intialData.cart_drawer,
    cart_dropdown: window.__intialData.cart_dropdown,
    cart_loading: window.__intialData.cart_loading,
    cart_alert: window.__intialData.cart_alert,
    cart_delay: window.__intialData.cart_delay,
    cart_delay_width: window.__intialData.cart_delay_width,
    cart_behavior: window.__intialData.cart_behavior,
    cart: window.__intialData.cart,
    progress_bar_threshold: window.__intialData.progress_bar_threshold,
    search_loading: window.__intialData.search_loading,
    search_active: window.__intialData.search_active,
    search_items: window.__intialData.search_items,
    search_items_pages: window.__intialData.search_items_pages,
    search_items_collections: window.__intialData.search_items_collections,
    search_items_articles: window.__intialData.search_items_articles,
    search_items_queries: window.__intialData.search_items_queries,
    collection_loading: window.__intialData.collection_loading,
    pagination_total_pages: window.__intialData.pagination_total_pages,
    pagination_current_page: window.__intialData.pagination_current_page,
    pagination_section: window.__intialData.pagination_section,
    filter_min_price: window.__intialData.filter_min_price,
    filter_max_price: window.__intialData.filter_max_price,
    filter_min: window.__intialData.filter_min,
    filter_max: window.__intialData.filter_max,
    filter_min_thumb: window.__intialData.filter_min_thumb,
    filter_max_thumb: window.__intialData.filter_max_thumb,
    // ------------- AGE VERIFICATION
    // - check age (if needed) and record to local storage
    // verifyAge(needsAge, ageLimit, enteredDate) {
    //   // if style is full date, verify that date
    //   if (needsAge) {
    //     // Need to calculate age from the entered date
    //     function parseDate(str) {
    //       var t = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    //       if (t !== null) {
    //         var d = +t[1],
    //           m = +t[2],
    //           y = +t[3];
    //         var date = new Date(y, m - 1, d);
    //         if (date.getFullYear() === y && date.getMonth() === m - 1) {
    //           return date;
    //         }
    //       }
    //       return null;
    //     }
    //     // if date is incomplete, throw error
    //     const parsedDate = parseDate(enteredDate);
    //     const errorNode = document.querySelector("#ageError");
    //     if (parsedDate === null) {
    //       errorNode.textContent = "Please complete the date form!";
    //     } else {
    //       // Date is good. Now to calculate age from date and compare to age limit
    //       function getAge(dateString) {
    //         var today = new Date();
    //         var birthDate = new Date(dateString);
    //         var age = today.getFullYear() - birthDate.getFullYear();
    //         var m = today.getMonth() - birthDate.getMonth();
    //         if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    //           age--;
    //         }
    //         return age;
    //       }
    //       const currentAge = getAge(parsedDate);
    //       // if too young
    //       if (currentAge < ageLimit) {
    //         errorNode.textContent = "Sorry, you are too young!";
    //       } else {
    //         localStorage.setItem("agePopupConfirmed", true);
    //         this.age_popup = true;
    //       }
    //     }
    //   } else {
    //     localStorage.setItem("agePopupConfirmed", true);
    //     this.age_popup = true;
    //   }
    // },
    // Check line items values
    checkLineItems: function checkLineItems(handle) {
      var inputs = document.querySelectorAll(".custom-input_".concat(handle));
      var inputsArr = Array.from(inputs);
      var requiredFields = inputsArr.filter(function (inp) {
        return inp.required;
      });

      if (requiredFields.some(function (field) {
        return field.value === '';
      })) {
        this.incomplete_fields = true;
      } else {
        this.incomplete_fields = false;
      }
    },
    // ------------ THEME COLOR
    // - check local storage and update alpine variable for theme color
    detectThemeColor: function detectThemeColor() {
      var html = document.querySelector("html");

      if (localStorage.getItem("themeColor") && localStorage.getItem("themeColor") === "dark") {
        html.classList.remove("is-light");
        this.theme_color = "is-dark";
      } else if (localStorage.getItem("themeColor") && localStorage.getItem("themeColor") === "light") {
        html.classList.remove("is-dark");
        this.theme_color = "is-light";
      }
    },
    // - update local storage and alpine variables for theme color
    toggleTheme: function toggleTheme(theme) {
      var html = document.querySelector("html");

      if (theme === "is-dark") {
        html.classList.remove("is-light");
        this.theme_color = "is-dark";
        localStorage.setItem("themeColor", "dark");
      } else if (theme === "is-light") {
        html.classList.remove("is-dark");
        this.theme_color = "is-light";
        localStorage.setItem("themeColor", "light");
      } else {
        this.theme_color = "";
        localStorage.setItem("themeColor", "");
      }
    },
    // ------------ CART
    // - fetch cart then update alpine variables and trigger cart action
    updateCart: function updateCart(openCart) {
      var _this = this;

      this.cart_loading = true;
      fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        // shopify things
        _this.cart.items = data.items;
        _this.cart.item_count = data.item_count;
        _this.cart.total_price = data.total_price;
        _this.cart.original_total_price = data.original_total_price;
        _this.cart.total_discount = data.total_discount;
        _this.cart.cart_level_discount_applications = data.cart_level_discount_applications; // custom properties

        _this.cart.shipping_gap = _this.progress_bar_threshold - _this.cart.total_price;
        _this.cart.shipping_progress = _this.cart.total_price / _this.progress_bar_threshold * 100 + "%"; // finish loading

        _this.cart_loading = false; // open cart if set

        if (openCart == true) {
          _this.cart_delay_width = "0%";

          if (_this.cart_behavior == "alert") {
            _this.cart_alert = true;
            setTimeout(function () {
              _this.cart_delay_width = "100%";
            }, 10);
            setTimeout(function () {
              _this.cart_alert = false;
            }, _this.cart_delay);
          }

          if (_this.cart_behavior == "drawer") {
            _this.cart_drawer = true;
          }

          if (_this.cart_behavior == "dropdown") {
            _this.cart_dropdown = true;
          }
        } // hide upsells
        // HIDDEN UNTIL WE FIGURE OUT WHY THIS BREAKS THE SLIDER
        // document
        //   .querySelectorAll(".upsell")
        //   .forEach(function (el) {
        //     el.classList.remove("hidden");
        //   });
        // this.cart.items.forEach(function (item) {
        //   document
        //     .querySelectorAll(
        //       ".upsell--" + item.product_id
        //     )
        //     .forEach(function (el) {
        //       el.classList.add("hidden");
        //     });
        // });

      })["catch"](function (error) {
        console.error("Error:", error);
        _this.cart_loading = false;
      });
    },
    // - call change.js to update cart item then use updateCart()
    changeCartItemQuantity: function changeCartItemQuantity(key, quantity, openCart, refresh) {
      var _this2 = this;

      this.cart_loading = true;
      var formData = {
        id: key.toString(),
        quantity: quantity.toString()
      };
      fetch("/cart/change.js", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this2.cart.items = data.items.map(function (item) {
          return _objectSpread({}, item);
        });

        if (refresh) {
          window.location.reload();
        } else {
          _this2.updateCart(openCart);
        }
      })["catch"](function (error) {
        console.error("Error:", error);
        _this2.cart_loading = false;
      });
    },
    // - call add.js to add cart item then use updateCart()
    addCartItem: function addCartItem(variantID, sellingPlanId, quantity, openCart, properties) {
      var _this3 = this;

      this.cart_loading = true;
      var formData;
      var propertiesArr = [];
      var propertiesObj;

      if (properties) {
        var _iterator = _createForOfIteratorHelper(properties),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var property = _step.value;
            propertiesArr.push([property.name, property.value]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (propertiesArr.length > 0) {
          propertiesObj = Object.fromEntries(propertiesArr);
        }
      } // update formData if sellingPlanId is available


      if (sellingPlanId == 0) {
        formData = {
          items: [{
            id: variantID,
            quantity: quantity,
            properties: propertiesObj
          }]
        };
      } else {
        formData = {
          items: [{
            id: variantID,
            quantity: quantity,
            selling_plan: sellingPlanId,
            properties: propertiesObj
          }]
        };
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(response) {
          var data;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return response.json();

                case 2:
                  data = _context.sent;

                  // good response
                  if (response.status === 200) {
                    _this3.cart.items = data.items.map(function (item) {
                      return _objectSpread({}, item);
                    });

                    _this3.updateCart(openCart);
                  } // error response
                  else {
                      _this3.error_title = data.message, _this3.error_message = data.description, _this3.show_alert = true;
                    }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }())["catch"](function (error) {
        console.error("Error:", error);
        _this3.cart_loading = false;
      });
    },
    // - add multiple itmes to cart, used for cart sharing
    addCartItems: function addCartItems(items) {
      var _this4 = this;

      var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.cart_loading = true;
      var formData = {
        items: items
      };

      if (clear) {
        this.cart_loading = true;
        fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          _this4.updateCart(true);
        }).then(function () {
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(formData)
          }).then( /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(response) {
              var data;
              return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return response.json();

                    case 2:
                      data = _context2.sent;

                      if (response.status === 200) {
                        _this4.cart.items = data.items.map(function (item) {
                          return _objectSpread({}, item);
                        });

                        _this4.updateCart(true);
                      } else {
                        _this4.error_title = data.message, _this4.error_message = data.description, _this4.show_alert = true;
                      }

                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }());
        })["catch"](function (error) {
          console.error("Error:", error);
          _this4.cart_loading = false;
        });
      } else {
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        }).then( /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(response) {
            var data;
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return response.json();

                  case 2:
                    data = _context3.sent;

                    if (response.status === 200) {
                      _this4.cart.items = data.items.map(function (item) {
                        return _objectSpread({}, item);
                      });

                      _this4.updateCart(true);
                    } else {
                      _this4.error_title = data.message, _this4.error_message = data.description, _this4.show_alert = true;
                    }

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }())["catch"](function (error) {
          console.error("Error:", error);
          _this4.cart_loading = false;
        });
      }
    },
    // - add items to cart if cartshare url available
    handleSharedCart: function handleSharedCart() {
      if (location.search.indexOf("cartshare") >= 0) {
        var query = location.search.substring(1);
        var qArray = query.split("&");
        var objArr = qArray.map(function (item) {
          if (item != "") {
            var properties = item.split(",");
            var obj = {};
            properties.forEach(function (property) {
              var tup = property.split(":");
              obj[tup[0]] = tup[1];
            });
            return obj;
          }
        });
        this.addCartItems(objArr, true);
      }
    },
    // generate url with query string based on cart contents
    generateUrl: function generateUrl() {
      var queryString = "";

      var serialize = function serialize(obj) {
        var str = [];

        for (var p in obj) {
          if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + ":" + encodeURIComponent(obj[p]));
          }
        }

        return str.join(",") + "&";
      };

      var filteredCart = this.cart.items.map(function (item) {
        return item = {
          cartshare: true,
          id: item.variant_id,
          quantity: item.quantity
        };
      });
      filteredCart.forEach(function (item) {
        queryString = queryString.concat(serialize(item));
      });
      return window.location.origin + "?" + queryString;
    },
    // ------------ SEARCH
    // - get search suggestions and update alpine variables
    fetchAndUpdateSearch: function fetchAndUpdateSearch(event, params) {
      var _this5 = this;

      var buildParams = function buildParams() {
        var paramsArr = [];

        for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          if (value) {
            paramsArr.push(key.toString());
          }
        }

        var paramsString = paramsArr.join();
        return paramsString;
      };

      var searchTerm = event.target.value;
      this.search_loading = true;

      if (searchTerm.length === 0 || !searchTerm.replace(/\s/g, "").length) {
        this.search_loading = false;
        this.search_items = [];
        return;
      }

      fetch("/search/suggest.json?q=".concat(searchTerm, "&resources[type]=product,collection,article,page,query&resources[limit]=6&[options][fields]=").concat(buildParams(), "&section_id=predictive-search")).then(function (response) {
        if (!response.ok) {
          var error = new Error(response.status);

          _this5.close();

          throw error;
        }

        return response.json();
      }).then(function (data) {
        var collections = data.resources.results.collections;
        var pages = data.resources.results.pages;
        var products = data.resources.results.products;
        var articles = data.resources.results.articles;
        var queries = data.resources.results.queries;
        _this5.search_items = products;
        _this5.search_items_collections = collections;
        _this5.search_items_pages = pages;
        _this5.search_items_articles = articles;
        _this5.search_items_queries = queries;
        _this5.search_loading = false;
      })["catch"](function (error) {
        _this5.error_title = error.message, _this5.error_message = error.description, _this5.show_alert = true, _this5.close();
        throw error;
      });
    },
    // ------------ COLLECTIONS
    // - load quick add with section render
    fetchAndRenderQuickAdd: function fetchAndRenderQuickAdd(product_handle, template) {
      fetch(window.Shopify.routes.root + "products/" + product_handle + "?section_id=quick-add").then(function (response) {
        return response.text();
      }).then(function (responseText) {
        var html = responseText;
        document.getElementById("js:quickAdd-" + template + "-" + product_handle).innerHTML = html;
      });
    },
    // - handle filter changes on max price
    handleMaxPriceFilter: function handleMaxPriceFilter() {
      this.filter_max_price = Math.max(this.filter_max_price, this.filter_min_price);
      this.filter_max_thumb = 100 - (this.filter_max_price - this.filter_min) / (this.filter_max - this.filter_min) * 100;
    },
    // - handle filter changes on min price
    handleMinPriceFilter: function handleMinPriceFilter() {
      this.filter_min_price = Math.min(this.filter_min_price, this.filter_max_price);
      this.filter_min_thumb = (this.filter_min_price - this.filter_min) / (this.filter_max - this.filter_min) * 100;
    },
    // handle filter change
    handleFilterChange: function handleFilterChange(id) {
      // show loading indication
      this.collection_loading = true; // reset pagination

      this.pagination_current_page = 1; // get filter data

      var filter = document.getElementById(id);
      var filterData = new FormData(filter);
      this.fetchAndRenderCollection(filterData);
    },
    // handle deleting filters
    handleFilterDelete: function handleFilterDelete(filterToReset) {
      // show loading indication
      this.collection_loading = true; // get filter data

      var filter = document.getElementById("js:desktopFilter");
      var filterData = new FormData(filter); // remove deleted filter

      filterData["delete"](filterToReset);

      if (filterToReset.indexOf("price") !== -1) {
        filterData["delete"]("filter.v.price.gte");
        filterData["delete"]("filter.v.price.lte");
        this.filter_min_price = this.filter_min;
        this.filter_max_price = this.filter_max;
      }

      this.fetchAndRenderCollection(filterData);
    },
    // handle deleting filters
    handleFilterDeleteAll: function handleFilterDeleteAll() {
      // show loading indication
      this.collection_loading = true; // reset filterData

      var filterData = new FormData();
      this.fetchAndRenderCollection(filterData);
    },
    // build urlFilter
    buildUrlFilter: function buildUrlFilter(filterData) {
      var urlFilter = "";

      var _iterator2 = _createForOfIteratorHelper(filterData.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var pair = _step2.value;

          if (pair[0].indexOf("price") !== -1) {
            if (pair[0] === "filter.v.price.lte") {
              if (pair[1] < this.filter_max) {
                urlFilter = urlFilter + "&" + pair[0] + "=" + pair[1];
              }
            }

            if (pair[0] === "filter.v.price.gte") {
              if (pair[1] > this.filter_min) {
                urlFilter = urlFilter + "&" + pair[0] + "=" + pair[1];
              }
            }
          } else {
            urlFilter = urlFilter + "&" + pair[0] + "=" + pair[1];
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return urlFilter;
    },
    // call section render api with data from filter
    fetchAndRenderCollection: function fetchAndRenderCollection(filterData) {
      var _this6 = this;

      // go back to top
      document.body.scrollTop = document.documentElement.scrollTop = 0; // loop through form data and build url

      var filterUrl = this.buildUrlFilter(filterData); // get search term

      var searchUrl = new URL(location.href).searchParams.get("q");
      searchUrl = "&q=" + searchUrl; // update page url

      history.pushState(null, null, window.location.pathname + "?" + filterUrl + searchUrl);
      fetch(window.location.pathname + "?section_id=" + this.pagination_section + filterUrl + searchUrl).then(function (response) {
        return response.text();
      }).then(function (responseText) {
        var html = responseText;
        document.getElementById("shopify-section-" + _this6.pagination_section + "").innerHTML = html;
        setTimeout(function () {
          _this6.collection_loading = false;
        }, 100);
      });
    },
    // check if next page is avaible and inject more products
    fetchAndRenderNextPage: function fetchAndRenderNextPage() {
      var _this7 = this;

      // check if new page is available
      if (this.pagination_current_page < this.pagination_total_pages) {
        // show loading
        this.collection_loading = true; // get filter data

        var filter = document.getElementById("js:desktopFilter"); // get pagination count

        var pageUrl = "&page=" + (this.pagination_current_page + 1); // get search thingy

        var searchUrl = new URL(location.href).searchParams.get("q");
        searchUrl = "&q=" + searchUrl; // build fetch url

        var fetchUrl = "";

        if (filter) {
          var filterData = new FormData(filter);
          var filterUrl = this.buildUrlFilter(filterData);
          fetchUrl = window.location.pathname + "?section_id=" + this.pagination_section + filterUrl + pageUrl + searchUrl;
        } else {
          fetchUrl = window.location.pathname + "?section_id=" + this.pagination_section + pageUrl + searchUrl;
        } // load new page with filters and sort


        fetch(fetchUrl).then(function (response) {
          return response.text();
        }).then(function (responseText) {
          // extract products and inject into grid
          var html = document.createElement("div");
          html.innerHTML = responseText;
          var htmlCleaned = html.querySelector("#js\\:results").innerHTML;
          document.getElementById("js:results").insertAdjacentHTML("beforeend", htmlCleaned);
          setTimeout(function () {
            _this7.collection_loading = false;
          }, 100); // update next page url

          _this7.pagination_current_page = _this7.pagination_current_page + 1;
        });
      } // if last pgae
      else {
          this.collection_loading = false;
        }
    },
    // ------------ EXTRAS
    // copy value of input to clipboard and focus element
    copyToClipboard: function copyToClipboard(id) {
      var copyText = document.getElementById(id);
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyText.value);
    }
  };
}; // ========
// - utility functions


bsl.utiltiy = {// check if element is in viewport
  // isInViewport: function (elem) {
  //   var bounding = elem.getBoundingClientRect();
  //   return (
  //     bounding.top >= 0 &&
  //     bounding.left >= 0 &&
  //     bounding.bottom <=
  //       (window.innerHeight ||
  //         document.documentElement.clientHeight) &&
  //     bounding.right <=
  //       (window.innerWidth ||
  //         document.documentElement.clientWidth)
  //   );
  // },
  // setCookie: function (name, value, days) {
  //   var expires = "";
  //   if (days) {
  //     var date = new Date();
  //     date.setTime(
  //       date.getTime() + days * 24 * 60 * 60 * 1000
  //     );
  //     expires = "; expires=" + date.toUTCString();
  //   }
  //   document.cookie =
  //     name + "=" + (value || "") + expires + "; path=/";
  // },
  // getCookie: function (name) {
  //   var nameEQ = name + "=";
  //   var ca = document.cookie.split(";");
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == " ")
  //       c = c.substring(1, c.length);
  //     if (c.indexOf(nameEQ) == 0)
  //       return c.substring(nameEQ.length, c.length);
  //   }
  //   return null;
  // },
  // eraseCookie: function (name) {
  //   document.cookie =
  //     name +
  //     "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  // },
  // replaceUrl: function (name, value) {
  //   var str = location.search;
  //   if (
  //     new RegExp("[&?]" + name + "([=&].+)?$").test(str)
  //   ) {
  //     str = str.replace(
  //       new RegExp("(?:[&?])" + name + "[^&]*", "g"),
  //       ""
  //     );
  //   }
  //   str += "&";
  //   str += name + "=" + value;
  //   str = "?" + str.slice(1);
  //   location.assign(
  //     location.origin +
  //       location.pathname +
  //       str +
  //       location.hash
  //   );
  // },
}; // ATOMS
// ========
// - use bsl.animation to replace and update classes when in view

bsl.animation = {
  init: function init() {
    // Setup IntersectionObserver to add classes on scroll
    // credit: https://onesheep.org/insights/animate-on-scroll-with-tailwind-css
    // credit: https://devdojo.com/tnylea/animating-tailwind-transitions-on-page-load
    // observerCallback for IntersectionObserver
    var observerCallback = function observerCallback(entries) {
      entries.forEach(function (entry) {
        var element = document.getElementById(entry.target.dataset.id); // Add the fadeIn class:

        if (entry.isIntersecting) {
          var replaceClasses = JSON.parse(entry.target.dataset.replace.replace(/'/g, '"'));
          var delay = entry.target.dataset.delay;
          var callback = entry.target.dataset.callback;
          var x = eval(callback);

          if (typeof x == "function") {
            x();
          }

          Object.keys(replaceClasses).forEach(function (key) {
            setTimeout(function () {
              if (element) {
                element.classList.remove(key);
                element.classList.add(replaceClasses[key]);
              } else {
                entry.target.classList.remove(key);
                entry.target.classList.add(replaceClasses[key]);
              }
            }, delay);
          });
        }
      });
    };

    var animationElements = document.querySelectorAll(".js\\:animation");
    var animationObserver = new IntersectionObserver(observerCallback);
    animationElements.forEach(function (target) {
      animationObserver.observe(target);
    });
  }
}; // INITILIZE ATOMS
// ========

bsl.animation.init();

/***/ }),

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _bsl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bsl */ "./src/js/bsl.js");
/* harmony import */ var instant_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! instant.page */ "./node_modules/instant.page/instantpage.js");
/* harmony import */ var instant_page__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(instant_page__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var alpinejs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! alpinejs */ "./node_modules/alpinejs/dist/module.esm.js");
/* harmony import */ var _alpinejs_trap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @alpinejs/trap */ "./node_modules/@alpinejs/trap/dist/module.esm.js");
/* harmony import */ var _alpinejs_intersect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @alpinejs/intersect */ "./node_modules/@alpinejs/intersect/dist/module.esm.js");
/* harmony import */ var _alpinejs_persist__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @alpinejs/persist */ "./node_modules/@alpinejs/persist/dist/module.esm.js");
// import custom stuff
 // instant page

 // import alpine stuff





alpinejs__WEBPACK_IMPORTED_MODULE_2__.default.plugin(_alpinejs_persist__WEBPACK_IMPORTED_MODULE_5__.default);
alpinejs__WEBPACK_IMPORTED_MODULE_2__.default.plugin(_alpinejs_trap__WEBPACK_IMPORTED_MODULE_3__.default);
alpinejs__WEBPACK_IMPORTED_MODULE_2__.default.plugin(_alpinejs_intersect__WEBPACK_IMPORTED_MODULE_4__.default);
window.Alpine = alpinejs__WEBPACK_IMPORTED_MODULE_2__.default;
alpinejs__WEBPACK_IMPORTED_MODULE_2__.default.start();

/***/ }),

/***/ "./src/css/tailwind.css":
/*!******************************!*\
  !*** ./src/css/tailwind.css ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ "use strict";
/******/ 
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, ["assets/style","/assets/vendor"], () => (__webpack_exec__("./src/js/main.js"), __webpack_exec__("./src/css/tailwind.css")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);